export enum MassTextAlertsModalName {
  SendMassTextAlertConfirmation = 'sendMassTextAlertConfirmation',
  SelectMassTextAlertCustomDateRange = 'selectMassTextAlertCustomDateRange',
}
